import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MUITable from "../../Common/MUITable";
import Loader from "../../Common/Loader/loader";
import { ExportZoneWiseSATsReport } from "../Reports/SATReports/SATTripToTSSCTP/ZoneWiseSATsReports/ExportZoneWiseSATsReport";
import HygieneObservationModal from "./HygieneObservationModal";
import useHygieneStore from "./store/hygieneStore";
import { ExportHygieneData } from "./ExportHygieneData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import isGHMC, { canWritePermission } from "../../Common/helper/helpar";
export const HygieneObservation = () => {
    const { hygieneObservations, loading, error, fetchHygieneObservations } = useHygieneStore();
    const [modalShow, setModalShow] = useState(false);
    // State to store selected filter value
    const [statusFilter, setStatusFilter] = useState("");
    const [selectedObservation, setSelectedObservation] = useState(null);
    const isProd = isGHMC()
    const [canWriteValue, setCanWriteValue] = useState(null);

    useEffect(() => {
        setCanWriteValue(canWritePermission("Hygiene Observation"));
    },[] )

    useEffect(() => {
        // Initial fetch without filters
        fetchHygieneObservations();
    }, []);

    // Function to fetch data with filters when clicking search
    const handleSearch = () => {
        fetchHygieneObservations({ isActive: statusFilter });
    };

    const hygieneHeaderColumns = [
        { label: "Observation Name", field: "observationName" },
        {
            label: "Status",
            field: "isActive",
            render: (row) => (row.isActive ? "Active" : "InActive"), // Convert boolean to text
        },
        {
            label: "Action",
            field: "action",
            render: (row, index) => (
                <div className="d-flex gap-2 justify-content-center" >
                    <button
                        className={`${index % 2 === 0 ? "bg-F8CCCD" : "bg-ddefff"} 
                        ${isProd ? "edit-ghmc" : "edit-swm"}`}
                        onClick={() => {
                            setSelectedObservation(row); // Set selected row data
                            setModalShow(true); // Open modal
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                </div>
            ),
        },
    ];


    return (
        <div style={{ width: "100%" }}>
            <div className="content">
                <div className="page-content">
                    <div className="page-header">
                        <div className="d-flex justify-content-between align-items-center">
                            {/* Left Side - Filters and Search Button */}
                            <div className="d-flex align-items-end gap-2 mb-2">
                                {/* Status Filter with Increased Width */}
                                <div style={{ width: "250px" }}> {/* Adjust width as needed */}
                                    <div className="form-group-filter">
                                        <label className="form-label" style={{ marginBottom: "-2px" }}>Status</label>
                                        <select
                                            id="status-filter-input"
                                            name="isActive"
                                            className="form-select bg-white w-100"
                                            value={statusFilter}
                                            onChange={(e) => setStatusFilter(e.target.value)}
                                        >
                                            <option value="">All</option>
                                            <option value="true">Active</option>
                                            <option value="false">Inactive</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Search Button */}
                                <button
                                    onClick={handleSearch}
                                    className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                                >
                                    Search
                                </button>
                            </div>

                            {/* Right Side - Export Button */}
                            <div className="mt-4 d-flex">
                                <div className="d-flex gap-2">
                                {canWriteValue === true && <button className="btn d-flex align-items-center"
                                        onClick={() => setModalShow(true)}
                                        style={{
                                            backgroundColor: "#fff",
                                            color: "#333333",
                                            borderRadius: "20px",
                                            padding: "6px 12px",
                                            border: "1px solid #CCCCCC",
                                        }}>
                                        <i className="fa-solid fa-plus me-1"></i> Add Hygiene Observation
                                    </button>}
                                </div>
                                <ExportHygieneData />
                            </div>
                        </div>

                        {/* Data Table Section */}
                        <div className="card mt-3">
                            <div className="card-body">
                                <div className="top-header">
                                    <span className="m-0">Hygiene Observation</span>
                                </div>
                                {/* Filter & Search Section */}


                                {loading ? <Loader /> : (
                                    <MUITable
                                        needSRNumber
                                        columns={hygieneHeaderColumns}
                                        rows={hygieneObservations}
                                        tableHeight={500}
                                    />
                                )}
                            </div>

                            <HygieneObservationModal
                                show={modalShow}
                                handleClose={() => {
                                    setModalShow(false);
                                    setSelectedObservation(null); // Clear selected data when closing modal
                                }}
                                selectedObservation={selectedObservation}
                                canWriteValue={canWriteValue}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
